export default __webpack_public_path__ + "static/media/04.2b1c2b25.png";